import Seo from "@/components/Seo";
import React from "react";
import { LegalPage, Section, P, Sub } from "@/components/Legal";

export default function Cookies() {
  return (
    <LegalPage title="Cookie Policy" updated="July 4, 2026" testid="cookies-page">
      <Seo title="Cookie Policy — WorldAIInfo" description="How WorldAIInfo uses cookies and how you can control them. Read our cookie policy." canonicalPath="/cookies" />
      <Section title="1. What Are Cookies">
        <P>Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences and understand how you use the site.</P>
      </Section>

      <Section title="2. Cookies We Use">
        <Sub label="Essential Cookies —">Required for the website to function. Cannot be disabled. Includes session management and security tokens. No personal data stored.</Sub>
        <Sub label="Analytics Cookies —">Help us understand how visitors use the platform including which pages are most visited and how long visitors stay. Data is aggregated and anonymous. Can be disabled in browser settings.</Sub>
        <Sub label="Preference Cookies —">Remember your settings such as filter preferences on the jobs board. Can be disabled but may affect your experience.</Sub>
        <P>We do NOT use advertising cookies, retargeting cookies, or third party tracking cookies.</P>
      </Section>

      <Section title="3. How to Control Cookies">
        <P>You can control cookies through your browser settings. Most browsers allow you to refuse cookies, delete existing cookies, and set preferences for specific websites. Disabling essential cookies may prevent some features from working correctly. For instructions on managing cookies visit your browser's help section.</P>
      </Section>

      <Section title="4. Third Party Cookies">
        <P>Stripe, our payment processor, may set cookies when you make a payment. These are governed by Stripe's cookie policy. We have no control over these cookies.</P>
      </Section>
    </LegalPage>
  );
}
